export const capDomains = [
    'cap.weltsparen.de',
    'cap.raisin.co.uk',
    'cap.staging-weltsparen.de',
    'cap.staging-raisin.co.uk',
    'cap.onboarding-weltsparen.de',
    'cap.onboarding-raisin.co.uk',
    'cap.dev-weltsparen.de',
    'cap.dev-raisin.co.uk',
];
//# sourceMappingURL=index.js.map